import { Component } from '@theme/component';

/** Real editor-supplied reviews only; empty state is rendered by Liquid. */
class FreyaHomepageDetails extends Component {
  #page = 0;
  #abort;
  connectedCallback() {
    super.connectedCallback();
    this.#abort?.abort();
    this.#abort = new AbortController();
    window.addEventListener('resize', () => { this.#page = 0; this.#render(); }, { signal: this.#abort.signal });
    this.#render();
  }
  updatedCallback() { super.updatedCallback(); this.#page = 0; this.#render(); }
  disconnectedCallback() { this.#abort?.abort(); super.disconnectedCallback(); }
  previous() { this.#move(-1); }
  next() { this.#move(1); }
  #size() { return matchMedia('(max-width:760px)').matches ? 1 : 3; }
  #move(delta) {
    const count = this.querySelectorAll('[data-review]').length;
    const pages = Math.ceil(count / this.#size());
    if (!pages) return;
    this.#page = (this.#page + delta + pages) % pages;
    this.#render();
  }
  #render() {
    const cards = [...this.querySelectorAll('[data-review]')];
    const size = this.#size();
    this.#page = Math.min(this.#page, Math.max(0, Math.ceil(cards.length / size) - 1));
    cards.forEach((card, i) => { card.hidden = i < this.#page * size || i >= (this.#page + 1) * size; });
    const controls = this.querySelector('[data-review-controls]');
    if (controls) controls.hidden = cards.length <= size;
    const status = this.querySelector('[data-review-status]');
    if (status) status.textContent = `${this.#page * size + 1}–${Math.min((this.#page + 1) * size, cards.length)} / ${cards.length}`;
  }
}
if (!customElements.get('freya-homepage-details')) customElements.define('freya-homepage-details', FreyaHomepageDetails);
